import { cn } from '@shared/lib'

type SpinnerSize = 'sm' | 'md' | 'lg'

interface Props {
  /** Spinner circle size: `sm` 20px, `md` 32px (default), `lg` 40px. */
  size?: SpinnerSize
  className?: string
  /** Accessible loading text. When set, the spinner becomes a `role="status"` live region
   *  with this text read out (sr-only); without it the spinner stays decorative. */
  label?: string
}

const SIZE_CLASS: Record<SpinnerSize, string> = {
  sm: 'size-5',
  md: 'size-8',
  lg: 'size-10',
}

export function Spinner({ size = 'lg', className = '', label }: Props) {
  return (
    <div
      role={label ? 'status' : undefined}
      className={cn('flex h-full w-full items-center justify-center', className)}
    >
      <div
        className={cn(
          'border-orange-subtle border-t-orange animate-spin rounded-full border-4',
          SIZE_CLASS[size]
        )}
      />
      {label && <span className="sr-only">{label}</span>}
    </div>
  )
}
